module.exports = __webpack_public_path__ + "img/subgroup_minus.994e60d7.svg";